import { ref } from '@vue/composition-api';
import { IBadge } from '@/bundles/Badge/interfaces';
import { IGetBadgeListDto, IUpdateBadgeInfoDto } from '@/bundles/Badge/dto';
import { badgeService } from '@/bundles/Badge/factory/badgeServiceFactory';
import Badge from '@/bundles/Badge/models/Badge';

export function useBadge () {
  const defaultBadgeData: IBadge = {
    id: 0,
    name: '',
    description: '',
    icon: '',
    created: new Date(),
    updated: new Date()
  };
  const badges = ref<IBadge[]>([]);
  const badge = ref<IBadge>(new Badge(defaultBadgeData));
  const total = ref(0);
  const listLoading = ref(false);
  const editLoading = ref(false);

  async function fetch (params: IGetBadgeListDto) {
    listLoading.value = true;
    const { data, total: count } = await badgeService.list(params);
    badges.value = data;
    total.value = count;
    listLoading.value = false;
  }

  async function edit (id: number, params: IUpdateBadgeInfoDto) {
    editLoading.value = true;
    badge.value = await badgeService.update(id, params);
    editLoading.value = false;
  }

  function resetBadge () {
    badge.value = new Badge(defaultBadgeData);
  }

  return {
    badges,
    badge,
    total,
    listLoading,
    editLoading,
    fetch,
    resetBadge,
    edit,
  };
}
